import useFilters from "@/core/hooks/useFilters";
import useTranslation from "@/core/hooks/useTranslation";
import TablePage, {
  ICustomBreadcrumbsLink,
} from "@/presentation/components/TablePage";
import sliceNames from "@/redux/names";
import articleCategoryEffects from "@/redux/slices/articleCategory/effects";
import { useSelector } from "@/redux/store";
import { useTheme } from "@mui/material";
import articleCategoryColumns from "./data/columns";
import {
  articleCategoryTableTopOptions,
  articleCategoryToolbarOptions,
} from "./data/constants";
import articleCategoryFields from "./data/fields";

interface IArticleCategoryProps {
  additionalFilters?: Record<string, string | undefined>;
  breadcrumbs?: null | ICustomBreadcrumbsLink[];
  noPage?: boolean;
}
export default function ArticleCategorysPage({
  additionalFilters,
  breadcrumbs,
  noPage,
}: IArticleCategoryProps) {
  // Store
  const { articleCategory, globalData } = useSelector((state) => state);

  // Hooks
  const t = useTranslation();
  const theme: any = useTheme();
  const {
    getData,
    handleKeyword,
    handlePaymentType,
    handleStatus,
    handleOrder,
    handleOrder_field,
    handlePage,
    handlePer_page,
    keyword,
    paymentType,
    status,
    order: _order,
    order_field,
  } = useFilters({
    effects: articleCategoryEffects,
    initialState: {
      page: articleCategory.list.current_page,
      per_page: articleCategory.list.per_page,
      keyword: "",
      paymentType: "",
      status: "",
      order: "",
      order_field: "",
      ...(additionalFilters ?? {}),
    },
  });

  return (
    <TablePage
      model={sliceNames.articleCategory}
      // ** Breadcrumbs **
      breadcrumbLinks={breadcrumbs}
      // ** Genre **
      female
      // ** Toolbar **
      tableTopOptions={articleCategoryTableTopOptions}
      toolbarOptionChange={handleStatus}
      currentToolbarOption={status}
      toolbarOptions={articleCategoryToolbarOptions({
        value: keyword,
        onChange: handleKeyword,
      })}
      // ** On Select rows **
      idProperty="uuid"
      // ** Table CRUD **
      fields={articleCategoryFields(t, [])}
      stateData={articleCategory}
      columns={articleCategoryColumns}
      effects={articleCategoryEffects}
      getData={getData}
      // ** Filter options **
      isFiltered={(data) =>
        keyword !== "" || paymentType !== "" || status !== ""
      }
      onReset={() => {
        handleKeyword("");
        handlePaymentType("");
        handleStatus("");
      }}
      // ** Sorting **
      handleFilterOrder={handleOrder}
      handleFilterOrderField={handleOrder_field}
      order={_order}
      orderField={order_field}
      // ** Pagination **
      onChangePage={handlePage}
      onChangeRowsPerPage={handlePer_page}
      noPage={noPage}
    />
  );
}
